import { useSelector } from 'react-redux';

/* 
    A small util for managing dialogs with the 'do not show again' feature.
    Using localStorage to store the state of the dialog visibility.
*/

const useDialogVisibility = (dialogKey: string) => {
  const therapistUUID = useSelector(
    (state: any) => state.getTherapistProfileReducer?.response?.data?.uuid
  );

  const localStorageKey = `${therapistUUID}_${dialogKey}`;

  const canShowDialog = () => {
    const storedValue = localStorage.getItem(localStorageKey);
    return storedValue !== 'true';
  };

  const setDoNotshowAgain = (doNotShowAgain: boolean) => {
    if (doNotShowAgain) {
      localStorage.setItem(localStorageKey, 'true');
    } else {
      localStorage.removeItem(localStorageKey);
    }
  };

  return { canShowDialog, setDoNotshowAgain };
};

export default useDialogVisibility;
